{
  "messages": {
    "loading": "Loading messages...",
    "empty": "No messages yet. Start the conversation!",
    "noEntitiesSelected": "Please select entities from the dropdown above to view messages.",
    "counter": "Messages / {{count}}",
    "reply": "Reply",
    "replyPlaceholder": "Write a reply...",
    "replyPlaceholderInternal": "Write an internal reply...",
    "replyPlaceholderClient": "Write a reply visible to clients...",
    "cancel": "Cancel",
    "send": "Send",
    "important": "Important",
    "scrollToBottom": "Scroll to bottom",
    "refresh": "Refresh messages",
    "newDivider": "New",
    "markRead": "Mark read",
    "markUnread": "Mark unread",
    "unknownAuthor": "Someone",
    "unreadCount": "{{count}} unread",
    "noMessages": "No messages",
    "messageCount": "{{count}} messages",
    "markedImportantBy": "! Marked important by {{name}}"
  },
  "tabs": {
    "internal": "Internal",
    "client": "Client",
    "all": "All"
  },
  "visibility": {
    "client": "Client",
    "internal": "Internal"
  },
  "thread": {
    "reply": "reply",
    "replies": "replies"
  },
  "filters": {
    "relatedEntities": "Related Entities",
    "selectEntities": "Select Entities",
    "selectEntitiesDescription": "View messages from multiple entities",
    "selectEntitiesPlaceholder": "Select entities...",
    "all": "All",
    "current": "Current",
    "typesSelected": "{{count}} types selected",
    "important": "Important",
    "showImportant": "Show Important",
    "showImportantOnly": "Show important messages only",
    "showAllMessages": "Show all messages",
    "allRelated": "All related",
    "someSelected": "{{count}} selected",
    "showUnread": "Unread",
    "showUnreadOnly": "Show only unread messages"
  },
  "input": {
    "placeholder": "Write a message...",
    "placeholderAllTab": "Switch to Internal or Client tab to send messages",
    "placeholderInternal": "Write an internal update...",
    "placeholderClient": "Write a message visible to clients...",
    "warningNote": "Note:",
    "warningMessage": "Select the current entity ({{entityKey}}) to send messages.",
    "pickAudience": "Pick Internal or Client to write — the combined view does not set an audience.",
    "visibleInternal": "Visible to your team only",
    "visibleClient": "Visible to the client"
  },
  "emoji": {
    "title": "Add Emoji",
    "popoverTitle": "Insert Emoji",
    "categories": {
      "Smileys": "Smileys",
      "Gestures": "Gestures",
      "Objects": "Objects",
      "Symbols": "Symbols"
    }
  },
  "tooltips": {
    "mentions": "@Mentions coming soon!",
    "attachments": "Attachments coming soon!",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "numberedList": "Numbered list",
    "bulletList": "Bullet list",
    "link": "Link",
    "showFormatting": "Show formatting",
    "hideFormatting": "Hide formatting",
    "insertEmoji": "Insert emoji",
    "sendMessage": "Send message (Ctrl+Enter)",
    "enterUrl": "Enter URL:",
    "addLink": "Add Link",
    "linkText": "Link text",
    "markAsImportant": "Mark as important",
    "markAsNormal": "Remove importance",
    "migrated": "Migrated",
    "important": "Important",
    "markRead": "Marks this message and everything older as read.",
    "markUnread": "Marks this message and everything newer as unread.",
    "importantLabel": "Important"
  },
  "time": {
    "justNow": "just now",
    "minuteAgo": "{{count}} minute ago",
    "minutesAgo": "{{count}} minutes ago",
    "hourAgo": "{{count}} hour ago",
    "hoursAgo": "{{count}} hours ago",
    "dayAgo": "{{count}} day ago",
    "daysAgo": "{{count}} days ago",
    "monthAgo": "{{count}} month ago",
    "monthsAgo": "{{count}} months ago",
    "yearAgo": "{{count}} year ago",
    "yearsAgo": "{{count}} years ago"
  },
  "accessibility": {
    "closeChatPanel": "Close chat panel",
    "openChat": "Open chat"
  },
  "subscription": {
    "join": "Join this conversation",
    "leave": "Leave this conversation",
    "mute": "Mute",
    "unmute": "Unmute",
    "muteTooltip": "Stop being notified about this chat. You keep access and can still open it any time.",
    "unmuteTooltip": "Start being notified about new messages here again.",
    "resolving": "Notifications",
    "resolvingTooltip": "Checking your notification setting for this chat…"
  },
  "participants": {
    "title": "Participants",
    "countLabel": "{{count}} on this chat",
    "empty": "Nobody has been added to this chat yet.",
    "loading": "Loading people…",
    "loadFailed": "Could not load the people on this chat.",
    "you": "You",
    "internal": "Internal",
    "client": "Client",
    "contextual": "From this record",
    "added": "Added",
    "muted": "Muted",
    "addPeople": "Add people",
    "searchPlaceholder": "Search by name or email…",
    "searching": "Searching…",
    "noCandidates": "Nobody left to add.",
    "noCandidatesForClient": "Only people already on this record can be added back.",
    "previouslyLeft": "Was on this chat before",
    "add": "Unmute",
    "remove": "Mute",
    "removeSelf": "Mute",
    "removeTooltip": "Stops their notifications. They keep access and can still open this chat from the record.",
    "removeSelfTooltip": "Stops your notifications. You keep access and can still open this chat from the record.",
    "addTooltip": "They will be notified about new messages here again.",
    "changeFailed": "Could not change that person. Please try again.",
    "entityTitle": "{{entity}} participants",
    "invitee": "Invitee",
    "addShort": "Add",
    "addBarTooltip": "Add someone so they are notified about new messages here. It does not change who can see this chat.",
    "countLabelWithMuted": "{{count}} on this chat · {{muted}} muted",
    "participation": {
      "added": "Added {{at}}",
      "removed": "Removed {{at}}",
      "joined": "Joined {{at}}",
      "left": "Left {{at}}"
    }
  }
}
